// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-comp=\"UiCompletionStepper\"][data-v-150d9672]{height:6px;min-width:12em;gap:2px}\n", ""]);
// Exports
module.exports = exports;
